/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoFusionModelsSessionPersonalizationListItem,
    MelcoFusionModelsSessionPersonalizationListItemFromJSON,
    MelcoFusionModelsSessionPersonalizationListItemFromJSONTyped,
    MelcoFusionModelsSessionPersonalizationListItemToJSON,
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoFusionModelsSessionPersonalizationListItem
 */
export interface MelcoModelsGenericList1MelcoFusionModelsSessionPersonalizationListItem {
    /**
     * 
     * @type {Array<MelcoFusionModelsSessionPersonalizationListItem>}
     * @memberof MelcoModelsGenericList1MelcoFusionModelsSessionPersonalizationListItem
     */
    list: Array<MelcoFusionModelsSessionPersonalizationListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoFusionModelsSessionPersonalizationListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoFusionModelsSessionPersonalizationListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoFusionModelsSessionPersonalizationListItemFromJSON(json: any): MelcoModelsGenericList1MelcoFusionModelsSessionPersonalizationListItem {
    return MelcoModelsGenericList1MelcoFusionModelsSessionPersonalizationListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoFusionModelsSessionPersonalizationListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoFusionModelsSessionPersonalizationListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoFusionModelsSessionPersonalizationListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoFusionModelsSessionPersonalizationListItemToJSON(value?: MelcoModelsGenericList1MelcoFusionModelsSessionPersonalizationListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoFusionModelsSessionPersonalizationListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


